import { NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';

@NgModule()
export class IconsModule {
  constructor(
    private _domSanitizer: DomSanitizer,
    private _matIconRegistry: MatIconRegistry
  ) {
    const timestamp = new Date().getTime();
    // Register icon sets
    this._matIconRegistry.addSvgIconSet(
      this._domSanitizer.bypassSecurityTrustResourceUrl(
        `assets/icons/material-twotone.svg?v=${timestamp}`
      )
    );
    this._matIconRegistry.addSvgIconSetInNamespace(
      'mat_outline',
      this._domSanitizer.bypassSecurityTrustResourceUrl(
        `assets/icons/material-outline.svg?v=${timestamp}`
      )
    );
    this._matIconRegistry.addSvgIconSetInNamespace(
      'mat_solid',
      this._domSanitizer.bypassSecurityTrustResourceUrl(
        `assets/icons/material-solid.svg?v=${timestamp}`
      )
    );
    this._matIconRegistry.addSvgIconSetInNamespace(
      'iconsmind',
      this._domSanitizer.bypassSecurityTrustResourceUrl(
        `assets/icons/iconsmind.svg?v=${timestamp}`
      )
    );
    this._matIconRegistry.addSvgIconSetInNamespace(
      'feather',
      this._domSanitizer.bypassSecurityTrustResourceUrl(
        `assets/icons/feather.svg?v=${timestamp}`
      )
    );
    this._matIconRegistry.addSvgIconSetInNamespace(
      'heroicons_outline',
      this._domSanitizer.bypassSecurityTrustResourceUrl(
        `assets/icons/heroicons-outline.svg?v=${timestamp}`
      )
    );
    this._matIconRegistry.addSvgIconSetInNamespace(
      'heroicons_solid',
      this._domSanitizer.bypassSecurityTrustResourceUrl(
        `assets/icons/heroicons-solid.svg?v=${timestamp}`
      )
    );
    this._matIconRegistry.addSvgIconSetInNamespace(
      'iconography',
      this._domSanitizer.bypassSecurityTrustResourceUrl(
        `assets/icons/iconography.svg?v=${timestamp}`
      )
    );
    this._matIconRegistry.addSvgIcon(
      'download_2',
      this._domSanitizer.bypassSecurityTrustResourceUrl(
        `assets/icons/icon-download.svg?v=${timestamp}`
      )
    );
    this._matIconRegistry.addSvgIcon(
      'share_2',
      this._domSanitizer.bypassSecurityTrustResourceUrl(
        `assets/icons/icon-share.svg?v=${timestamp}`
      )
    );
    this._matIconRegistry.addSvgIcon(
      'calendar_2',
      this._domSanitizer.bypassSecurityTrustResourceUrl(
        `assets/icons/icon-datepicker.svg?v=${timestamp}`
      )
    );
  }
}
